import React from 'react';
import Loadable from 'react-loadable';
import LoadableLoading from 'components/LoadableLoading';
import { getAreas, getServiceOrgAvailableColumns } from './api';

export const path = '/service-org/list';

const PageServiceOrg: React.FC = (props) => {
  const ServiceOrg = Loadable.Map({
    loader: {
      page: () => import('./page'),
      columns: getServiceOrgAvailableColumns,
      areas: getAreas,
    },
    loading: LoadableLoading,
    render(loaded, loadedProps: {}) {
      const Page = loaded.page.default;

      return <Page {...loadedProps} {...loaded} />;
    },
  });

  return <ServiceOrg {...props} />;
};

export default PageServiceOrg;
